module.exports = __webpack_public_path__ + "static/media/isophya_camptoxypha_022_APA.309189bf.mp3";